module.exports = __webpack_public_path__ + "static/media/icon-globe.192c3b15.svg";